import { useEffect, useCallback, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Button, Container } from '@mui/material'
import Layout from '../../components/Layout'
import { GET_ALL_ITEMS_DATA } from '../../store/types'
import { SearchComponent } from '../order/OrderAnalytics'
import { getAllItemsData } from '../../store/actions/itemAction'
import ItemAllDataList from '../../components/item/ItemAllDataList'

const ItemAllData = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { itemsData } = useSelector((state) => state.item)

    const [searchFromDate, setSearchFromDate] = useState('')
    const [searchToDate, setSearchToDate] = useState('')

    const searchSubmit = useCallback(
        (e) => {
            e.preventDefault()
            if (!searchFromDate || !searchToDate) {
                alert('Please select start and end date')
                return
            }
            dispatch(getAllItemsData(searchFromDate, searchToDate))
        },
        [dispatch, searchFromDate, searchToDate]
    )

    useEffect(
        () => () => {
            dispatch({
                type: GET_ALL_ITEMS_DATA,
                payload: null,
            })
        },
        [dispatch]
    )

    return (
        <Layout>
            <Container>
                <Button
                    variant="outlined"
                    color="grey"
                    onClick={() => navigate(-1)}
                >
                    Back
                </Button>
                <SearchComponent
                    setSearchFromDate={setSearchFromDate}
                    setSearchToDate={setSearchToDate}
                    searchFromDate={searchFromDate}
                    searchToDate={searchToDate}
                    searchSubmit={searchSubmit}
                />
                {itemsData?.length === 0 && 'No Data'}
                {itemsData?.length > 0 && (
                    <ItemAllDataList
                        ItemsData={itemsData}
                        startDate={searchFromDate}
                        endDate={searchToDate}
                    />
                )}
            </Container>
        </Layout>
    )
}

export default ItemAllData
